const watchScroll = function () {
  // フェードインアニメーション
  const target = document.getElementsByClassName("fade-in-slide-in");
  const position = Math.floor(window.innerHeight * 0.8);

  for (let i = 0; i < target.length; i++) {
    let offsetTop = Math.floor(target[i].getBoundingClientRect().top);

    if (offsetTop < position) {
      target[i].classList.add("is-animate");
    }
  }

  // ファーストビューフェードアウトアニメーション
  // 現在のスクロール位置.ブラウザによって取る値が違うので全部取って最大値を算出.
  const scroll = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
  const opacity = 1 - scroll / (window.innerHeight * 0.8);
  const targetImage = document.getElementById("top-image");
  // 背景動画の透明度を変える. 描画負荷を下げるために0以下にはしない.
  if (opacity >= 0) {
    // 描画負荷を下げるために小数点を丸める
    const opacityCeiled = Math.ceil(opacity * 10) / 10;
    targetImage.style.opacity = opacityCeiled;
  } else {
    // elseにくるのはファーストビュー以上にスクロールしている時
    targetImage.style.opacity = 0;
  }
};

window.addEventListener("scroll", watchScroll, false);

window.addEventListener('load', function(){

  const targetImage = document.getElementById("background-image");
  const titleList = document.querySelectorAll(".title-logo-animation > .title > img");
  const subtitleSP = document.getElementById("subtitle-sp");
  const subtitlePC = document.getElementById("subtitle-pc");
  const scrollLogo = document.getElementById("scroll");
  targetImage.style.animationPlayState = "running";
  titleList.forEach(t => t.style.animationPlayState = "running");
  subtitlePC.classList.add("top-animation");
  subtitleSP.classList.add("top-animation");
  scrollLogo.classList.add("top-animation");
});
